import { BaseLookupModel, PaginationFilterRequest } from "./core.model";

export enum ClubAlbumMediaType {
    Image = 1,
    Video = 2
}

export enum ClubAlbumImageStatus {
    Pending = 1,
    Approved = 2,
    Rejected = 3
}

export const ClubAlbumImageStatusList = [
    { value: ClubAlbumImageStatus.Pending, label: "Pending" },
    { value: ClubAlbumImageStatus.Approved, label: "Approved" },
    { value: ClubAlbumImageStatus.Rejected, label: "Rejected" },
];

export interface RunningClubAlbumImage {
    id: number;
    link: string;
    runningClubAlbumId: number;
    mediaType: ClubAlbumMediaType;
    approvalStatus: ClubAlbumImageStatus;
    approvedAt?: string;
    createdAt: string;
    uploader?: BaseLookupModel;
    approvedByUser?: BaseLookupModel;
}

export class ClubAlbumImagePaginationFilterRequest extends PaginationFilterRequest {
    albumId?: number;
    approvalStatus?: ClubAlbumImageStatus;
}
